import { render, staticRenderFns } from "./GraficaReportePonencia.vue?vue&type=template&id=b12c97c0&class=results-graph"
import script from "./GraficaReportePonencia.vue?vue&type=script&lang=js"
export * from "./GraficaReportePonencia.vue?vue&type=script&lang=js"
import style0 from "./GraficaReportePonencia.vue?vue&type=style&index=0&id=b12c97c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports